
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[pageId]/[pageSlug]",
      function () {
        return require("private-next-pages/blog/[pageId]/[pageSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[pageId]/[pageSlug]"])
      });
    }
  